import React from 'react';

import classes from './Backdrop.module.css'

const backdrop = props => (
    props.show ? <div className={classes.Backdrop} onClick={props.click}><i className={["icon ion-md-close", classes.Close].join(' ')}></i></div> : null
);

export default backdrop;